import { FC, ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import { cn } from 'lib/utils';
import { SearchContext } from 'components/search/GlobalSearchPopup';

interface LayoutProps {
  children: ReactNode;
  floatingHeader?: boolean;
  showSearchBar?: boolean;
  showProfile?: boolean;
  linkLogo?: boolean;
  searchContext?: SearchContext;
}

const Layout: FC<LayoutProps> = ({
  children,
  floatingHeader = false,
  showSearchBar = true,
  showProfile = true,
  linkLogo = true,
  searchContext = { scope: 'global' },
}) => (
  <div className="grid relative justify-center min-h-full w-full">
    <div className="grid relative w-screen grid-rows-[auto_1fr_auto] grid-cols-[100%] justify-center">
      <Header
        showSearchBar={showSearchBar}
        showProfile={showProfile}
        searchContext={searchContext}
        linkLogo={linkLogo}
      />
      <main
        className={cn(
          'block relative w-full min-h-full m-auto max-page-width',
          floatingHeader ? '-mt-[104px]' : ''
        )}
      >
        {children}
      </main>
      {showProfile ? <Footer /> : null}
    </div>
  </div>
);

export default Layout;
